import { LazyMotion, domAnimation, m } from "framer-motion"
import React, { useEffect, useState } from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import { actionUrlConverter, imgUrlConverter } from '../../util'
import { container, product, settings } from './constants'
import { PriceComponent } from './price'

export const CatalogBrowseProductTiles = React.memo(({ appData: { catalogBrowseData }, appData: { pageContentData } }) => {
    const [catalogProductData, setCatalogProductData] = useState([])

    const catalogBrowseProductTiles = pageContentData?.find(data => data.contentType === "catalogBrowseProducts")

    useEffect(() => {
        const catalogProductArray = []
        Object.keys(catalogBrowseData) && Object.keys(catalogBrowseData).length > 0 && Object.keys(catalogBrowseData).forEach((catalogData) =>
            catalogBrowseData[catalogData]?.productGroups && Object.keys(catalogBrowseData[catalogData]?.productGroups).length > 0 && Object.keys(catalogBrowseData[catalogData]?.productGroups).forEach((objKey) =>
                catalogData?.split("-")?.length === 3 &&
                catalogProductArray.push(catalogBrowseData[catalogData].productGroups[objKey])
            ))
        setCatalogProductData(catalogProductArray)
    }, [catalogBrowseData])

    if (catalogBrowseProductTiles) {
        return (
            <LazyMotion features={domAnimation}>
                <div className="product-categories" >
                    {
                        catalogProductData?.length > 0 && catalogProductData.sort((a, b) => a.orderSeq - b.orderSeq)?.map((categoryObj, key) => {
                            let foundInPageContext = false
                            settings.arrows = categoryObj?.products?.length > 6 ? true : false;

                            return (
                                <div className="row mx-2" key={key}>
                                    <div className='mb-2'>
                                        <span className="h6 pe-2" role="button" tabIndex="0">{categoryObj?.displayName}</span>
                                        <a
                                            href={actionUrlConverter(categoryObj?.actionUrl)}
                                            className="fa-xs text-underline">{`Shop all (${categoryObj?.products?.length})`}
                                        </a>
                                    </div>
                                    <hr />
                                    <m.div
                                        className="container-fluid"
                                        variants={container}
                                        initial="hidden"
                                        animate="show"
                                    >
                                        <Slider {...settings} className="carousel">
                                            {categoryObj?.products?.map((productObj, key) => {
                                                return (
                                                    <m.div
                                                        key={`ProductObj-${key}`}
                                                        className="product"
                                                        variants={product}>
                                                        {catalogBrowseProductTiles?.items?.map((imageObj, index) => {
                                                            if (imageObj.productOsr === productObj.productOsr) {
                                                                foundInPageContext = true
                                                                return <>
                                                                    <a href={actionUrlConverter(productObj?.actionUrl)}>
                                                                        <div key={index} className="img"><img src={imgUrlConverter(imageObj.images?.md)} alt={productObj?.displayName} /></div>
                                                                        <div className="ms-4">
                                                                            <div className="text-underline product-name-font">{productObj?.displayName}</div>
                                                                            <PriceComponent data={productObj} />
                                                                        </div>
                                                                    </a>
                                                                </>
                                                            }
                                                            return true
                                                        })
                                                        }

                                                        {(!foundInPageContext) &&
                                                            <div key={`ImageObjItem-${key}`} className="product" variants={product}>
                                                                <a href={actionUrlConverter(productObj?.actionUrl)}>
                                                                    <div className="img"><img src={imgUrlConverter(productObj?.imageUrl)} alt={productObj?.displayName} /></div>
                                                                    <div className="ms-4">
                                                                        <div className="text-underline product-name-font">{productObj?.displayName}</div>
                                                                        <PriceComponent data={productObj} />
                                                                    </div>
                                                                </a>
                                                            </div>}
                                                    </m.div>)
                                            })}
                                        </Slider>
                                    </m.div>
                                </div>)
                        }
                        )
                    }
                </div>
            </LazyMotion>)
    } else {
        return null
    }
})
